import { useTranslation } from 'react-i18next';
import styles from './MailCardVerseQuestion.module.css';

interface MailCardVerseQuestionProps {
  onInclude: () => void;
  onSkip: () => void;
}

/**
 * Q1 surface for MailCardSheet (show-my-name only per round-9 § 0.1).
 * Add-a-verse / Skip-verses prompt. Add routes the parent's surface
 * to `'versePicker'` (ShareVersePicker mounts in the sheet body);
 * Skip advances to Q2 (or, when the prayer has no cardLabel noun,
 * straight to Q3 via advanceFromQ1's skip branch).
 *
 * Phase 1 i18n keys consumed: mailCard.versePrompt,
 * mailCard.verseIncludeBtn, mailCard.verseSkipBtn.
 */
export default function MailCardVerseQuestion({
  onInclude,
  onSkip,
}: MailCardVerseQuestionProps) {
  const { t } = useTranslation();

  return (
    <section
      className={styles.question}
      aria-labelledby="mailcard-verse-prompt"
    >
      <h2 className={styles.prompt} id="mailcard-verse-prompt">
        {t('mailCard.versePrompt')}
      </h2>
      <div className={styles.actions}>
        <button
          type="button"
          className={styles.primary}
          onClick={onInclude}
          aria-label={t('mailCard.verseIncludeBtn')}
        >
          {t('mailCard.verseIncludeBtn')}
        </button>
        <button
          type="button"
          className={styles.secondary}
          onClick={onSkip}
          aria-label={t('mailCard.verseSkipBtn')}
        >
          {t('mailCard.verseSkipBtn')}
        </button>
      </div>
    </section>
  );
}
